<div class="row">
  <div class="col-12">
    <div class="card mb-3">
      <div class="card-body">
        <h2>{{ editingID ? 'Edit and Resubmit Reimbursement' : 'Request Reimbursement' }}</h2>
        <p class="text-muted">Submit an eligible expense for HR payroll review. A receipt or image is required for a new request.</p>

        <div class="row">
          <div class="form-group col-12 col-md-6">
            <label for="reimbursementType">Reimbursement Type</label>
            <select id="reimbursementType" class="form-control" [(ngModel)]="request.reimbursementTypeID">
              <option [ngValue]="null">Select a type...</option>
              <option *ngFor="let type of reimbursementTypes" [ngValue]="type.id">{{ type.name }}</option>
            </select>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="expenseDate">Expense Date</label>
            <input id="expenseDate" type="date" class="form-control" [max]="maximumExpenseDate" [(ngModel)]="request.expenseDate">
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="merchant">Merchant or Payee</label>
            <input id="merchant" type="text" class="form-control" maxlength="200" [(ngModel)]="request.merchant">
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="requestedAmount">Requested Amount</label>
            <div class="input-group">
              <div class="input-group-prepend"><span class="input-group-text">$</span></div>
              <input id="requestedAmount" type="number" min="0.01" max="1000000" step="0.01" class="form-control" [(ngModel)]="request.requestedAmount">
            </div>
          </div>
          <div class="form-group col-12">
            <label for="reimbursementDescription">Description or Business Purpose</label>
            <textarea id="reimbursementDescription" class="form-control" rows="3" maxlength="2000" [(ngModel)]="request.description"></textarea>
          </div>
          <div class="form-group col-12">
            <label for="receipt">Receipt or Image</label>
            <input #receiptInput id="receipt" type="file" class="form-control-file" accept="image/*,.pdf" (change)="receiptChanged($event)">
            <small *ngIf="editingID" class="form-text text-muted">Leave this blank to keep the current receipt, or choose a replacement.</small>
          </div>
          <div class="form-group col-12">
            <div class="form-check">
              <input id="reimbursementConfirmation" class="form-check-input" type="checkbox" [(ngModel)]="request.confirmed">
              <label class="form-check-label" for="reimbursementConfirmation">
                I confirm this reimbursement request is complete and accurate. Selecting Request Reimbursement serves as my signature.
              </label>
            </div>
          </div>
        </div>

        <button id="requestReimbursementButton" type="button" class="btn btn-primary" [disabled]="submitting" (click)="submit()">
          {{ submitting ? 'Submitting...' : (editingID ? 'Resubmit Reimbursement' : 'Request Reimbursement') }}
        </button>
        <button *ngIf="editingID" type="button" class="btn btn-link" [disabled]="submitting" (click)="cancelEdit()">Cancel</button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h3>My Reimbursement Requests</h3>
        <i *ngIf="loading" class="material-icons rotate text-muted">loop</i>
        <div *ngIf="!loading && !reimbursements.length" class="alert alert-info">No reimbursement requests have been submitted.</div>
        <div *ngIf="!loading && reimbursements.length" class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Status</th>
                <th>Type</th>
                <th>Expense Date</th>
                <th>Merchant</th>
                <th>Requested</th>
                <th>Approved</th>
                <th>Receipt</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let reimbursement of reimbursements" [attr.data-reimbursement-id]="reimbursement.id">
                <td><span class="badge" [ngClass]="statusClass(reimbursement.statusID)">{{ reimbursement.status }}</span></td>
                <td>{{ reimbursement.reimbursementType }}</td>
                <td>{{ reimbursement.expenseDate | date:'MM/dd/yyyy' }}</td>
                <td>
                  {{ reimbursement.merchant }}
                  <div *ngIf="reimbursement.denialReason" class="text-danger small">Reason: {{ reimbursement.denialReason }}</div>
                </td>
                <td>{{ reimbursement.requestedAmount | currency }}</td>
                <td>{{ reimbursement.approvedAmount != null ? (reimbursement.approvedAmount | currency) : '-' }}</td>
                <td><button type="button" class="btn btn-link p-0" (click)="downloadReceipt(reimbursement)">{{ reimbursement.receiptFileName }}</button></td>
                <td><button *ngIf="reimbursement.statusID === reimbursementStatus.Denied" type="button" class="btn btn-sm btn-outline-primary" (click)="edit(reimbursement)">Edit and Resubmit</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
